<template>
  <div class="calico-selected-claim-business">
    <CalicoBusinessCard
      class="claim-business-card"
      :value="business.id"
      :model-value="business.id"
      :title="business.name"
      :description="business.description || business.type"
      :city="business.city"
      :state="business.state"
      :address="business.street"
      :zip="business.zip"
      :phone-number="business.phone"
      :image="computedImage"
      :disabled="true"
      :non-operating="false"
    />
  </div>
</template>

<script>
import CalicoBusinessCard from "@/components/calico/businessCard/index.vue";

export default {
  name: "SelectedClaimBusiness",

  components: {
    CalicoBusinessCard
  },

  props: {
    business: {
      type: Object,
      required: true
    }
  },

  computed: {
    computedImage() {
      const rawPhoto = this.business?.placesData?.[0]?.business_photo;
      
      const placeImage =
        typeof rawPhoto === "string"
          ? rawPhoto.trim?.()
          : rawPhoto?.photoUri?.trim?.();

      if (placeImage) return placeImage;

      return null;
    }
  }

};
</script>

<style lang="scss" scoped>
.calico-selected-claim-business {
  @include stack-space($space-medium);
  width: 100%;
}

:deep(.calico-business-card .container) {
  background: $color-white;
  border-color: $color-neutral-light;
  cursor: default;
  transition: none;
}

:deep(.calico-business-card .disabled) {
  background: $color-white;
  color: inherit;
}
</style>
